export default "__VITE_ASSET__e57ae584__"